import { Component, ElementRef, HostBinding } from '@angular/core';
import { WizConstants } from '@wizeoo/akm-compute-lib';
import { WIZ_EVENT_TYPE} from '@wizeoo/akm-core-lib';
import { IWizItemRenderer, WizBaseCollector, WizEventManager, WizEvent } from '@wizeoo/akm-component-lib';

import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { ALK_EVENT_TYPE } from '../../../../model/enums';

/**
 * rendu des champs disponibles
 */
@Component({
  selector: 'chart-edit-item-renderer',
  templateUrl: './chart-edit-item.renderer.html',
})
export class ChartEditItemRenderer implements IWizItemRenderer<null, PivotField> {
  @HostBinding('style.width') forcedWidth = '100%';
  
  constructor(public elementRef: ElementRef) {}

  data: PivotField;
  owner: WizBaseCollector;

  /** mise en évidence des formules I */
  public dataClass(): string {
    if(this.data.mode && this.data.mode ===  WizConstants.MEASURE_MODE_INTERACT) {
      return 'contentLabel';
    }
    return null;
  }

  /** l'élément est actuellement utilisé */
  public isUsed(): boolean {
    // console.log('owner', this.owner);
    return !this.isInContentList() && this.data.isUsed; // affichage de l'oeil uniquement dans la liste de choix
  }

  /** icone de suppression du champ de la zone de contenu, affichage uniquement dans les zones de drop */
  public isInContentList(): boolean {
    // console.log('owner', this.owner);
    return this.owner.id !== 'fieldList' && this.owner.id !== 'measureList';
  }

  /** suppression d'un élément des zones de contenu */
  public doDelete(): void {
    this.owner.wizDataProvider.removeItem(this.data);
    WizEventManager.dispatchEvent(this.owner.elementRef, new WizEvent(WIZ_EVENT_TYPE.DELETE, null, this.data));
  }

  /** ouverture de la sub-pop pour configurer la formule (et à terme, le style) */
  public showConf(): void {
    WizEventManager.dispatchEvent(
      this.owner.elementRef,
      new AlkEvent(ALK_EVENT_TYPE.PIVOT_CONFIGURE_FIELD, [this.data, this.owner])
    );
  }
}
